module.exports = __webpack_public_path__ + "img/電気回路_5_4_5.7e9d77c5.png";